"use strict";

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Text = _interopRequireDefault(require("./Text"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = require("styled-components");

var _theme = _interopRequireDefault(require("./theme"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      &:after {\n        content: '\u203A';\n        padding-left: 0.25em;\n      }\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      &:before {\n        content: '\u2039';\n        padding-right: 0.25em;\n      }\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      &:focus,\n      &:hover {\n        text-decoration: underline;\n      }\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  text-decoration: ", ";\n\n  ", ";\n\n  &:before,\n  &:after {\n    text-decoration: none !important;\n    display: inline-block;\n  }\n  ", ";\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Link = _Text["default"].withComponent('a').extend(_templateObject(), function (props) {
  return props.underline ? 'underline' : 'none';
}, function (props) {
  return props.hoverline && (0, _styledComponents.css)(_templateObject2());
}, function (props) {
  return props.chevronLeft && (0, _styledComponents.css)(_templateObject3());
}, function (props) {
  return props.chevronRight && (0, _styledComponents.css)(_templateObject4());
});

Link.displayName = 'Link';
Link.propTypes = {
  /** you know, where the link goes */
  href: _propTypes["default"].string,

  /** enable text-decoration: underline */
  underline: _propTypes["default"].bool,

  /** enable text-decoration: underline on hover*/
  hoverline: _propTypes["default"].bool,

  /** add left text arrows */
  chevronLeft: _propTypes["default"].bool,

  /** add right text arrows */
  chevronRight: _propTypes["default"].bool
};
Link.defaultProps = {
  theme: _theme["default"],
  color: 'info'
};
var _default = Link;
exports["default"] = _default;